import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import { makeRequest, METHODS } from './baseRequest.js';
import settings from '../settings.js';
import { buildUrl } from '../utils/buildUrl.js';

function validateProducts(products, platform) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = buildUrl(settings.productsValidateUrl, {
            platform,
            backendUrl: settings.backendUrl,
            storefrontName: settings.storefrontName,
        });
        return makeRequest(METHODS.POST, url, {
            products: products.map((product) => ({
                externalProductId: product.externalProductId,
                currencyCode: product.currency,
                currentPrice: product.price,
                originalPrice: product.originalPrice || product.price,
            })),
        });
    });
}

export { validateProducts };
//# sourceMappingURL=validate.js.map
